import { useEffect, useRef, useState } from "react";
import { setSoundOn } from "../audio/audioEngine";

export const previewRefresh = "td:dashboard-refresh";

const inPreview = () => {
  try {
    return (
      window.self !== window.top &&
      new URLSearchParams(window.location.search).get("preview") === "1"
    );
  } catch {
    return false;
  }
};

export function usePreview(refresh) {
  const [preview] = useState(() => {
    const on = inPreview();
    if (on) setSoundOn(false, { remember: false });
    return on;
  });

  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;

  useEffect(() => {
    if (!preview) return undefined;
    const onMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.type !== previewRefresh) return;
      refreshRef.current();
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [preview]);

  return preview;
}
